<template>
  <div class="container">
    <div class="row">

      <div>
        <img :src="isFreeUser ? require('@/assets/logos/logo-free.png') : require('@/assets/logos/logo-vip.png')"  class="logo col-5 px-3 mt-2" alt="logo" />
      </div>

      <div class="d-flex flex-column justify-content-center align-items-center col-12 mb-4 mt-4">
        <CarouselComponent season="all" />
      </div>

      <div class="bold text-center mt-5">Click Yes to confirm your subscription</div>
      <div class="bold text-center">to Mzansi Rhythm VIP</div>

      <div class="normalText text-center mt-2">{{ selectedPlanText }} Subscription service</div>
      <div class="normalText text-center">FIRST DAY FREE</div>
      <div v-if="subscriptionError" class="text-danger text-center fw-bold mt-3 fs-6">Subscription Failed</div>
      <div class="yes mx-auto text-center mt-4 border p-3 col-11" @click="confirmSubscription">YES</div>

      <div class="cancel text-center mt-4" @click="cancel">Cancel</div>

      <div class="normalText2 text-center mt-5">This is a subscription service. To manage your </div>
      <div class="normalText2 text-center">subscription click profile > manage subscription</div>
      <div class="normalText2 text-center">Terms and Conditions</div>

    </div>
  </div>
</template>

<script>
import CarouselComponent from "@/views/components/CarouselComponent.vue";
import DepService from "@/api/services/depService";
import { mapState, mapMutations } from "vuex";

export default {
  name: "UpgradePackageConfirmationView",
  components: {
    CarouselComponent
  },

  data() {
    return {
      planDetails: {
        daily: 'R5/Day',
        weekly: 'R35/Week',
        monthly: 'R45/Month'
      },
      subscriptionError: false,
    }
  },

  computed: {
    ...mapState(['user', 'productId', 'isFreeUser']),

    selectedPlanText() {
      const planType = this.$route.query.plan;
      return this.planDetails[planType] || 'R5/Day';
    }
  },

  methods: {
    ...mapMutations(['setIsLoading', 'setUser']),

    async confirmSubscription() {
      this.setIsLoading(true);

      try {
        const subscriptionId = this.$route.query.subscriptionId;
        const serviceId = this.$route.query.serviceId;

        if (!subscriptionId || !serviceId) {
          console.error('Missing subscription details');
          this.$router.push('/upgrade-package');
          return;
        }

        // Subscribe the user using DepService
        const response = await DepService.subscribeUser(
            this.user.msisdn,
            serviceId,
            subscriptionId,
            this.productId,
            0,  // assuming 0 for some parameter based on ManageSubscription
            null // assuming null for some parameter based on ManageSubscription
        );

        this.setIsLoading(false);

        if (!response.data.result) {
          // Handle subscription failure
          this.subscriptionError === false
        }

        if (response.data.result) {
          // Update user in store
          this.setUser(response.data.user);

          // Navigate to profile or success page
          this.$router.push('/profile');
        }

      } catch (error) {
        this.setIsLoading(false);
        console.error('Error confirming subscription:', error);
      }
    },

    cancel() {
      this.$router.push('/upgrade-package');
    },

  },
}
</script>

<style scoped>
.yes {
  background-color: #FFCB05;
  border-radius: 30px;
  font-family: "Clash Display", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 19px;
  color: #000000;
  cursor: pointer;
  transition: all 0.3s ease;
}

.yes:hover {
  background-color: #e6b700;
  transform: scale(1.02);
}

.cancel {
  font-family: "Clash Display", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: black;
  cursor: pointer;
}

.normalText2 {
  font-family: "Clash Display", sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  color: #000F56;
}

.bold {
  font-family: "Clash Display", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  color: #000F56;
}

.normalText {
  font-family: "Clash Display", sans-serif;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  color: #000F56;
}
</style>